import { FC } from 'react'
import gql from 'graphql-tag'
import {
  RecruitListItem_ActivityFragment,
  RecruitListItem_CurrentUserFragment,
} from 'generated/graphql'
import ActivityTableRow from './ActivityTableRow.desktop'

gql`
  fragment RecruitListItem_currentUser on User {
    id
    ...ActivityTableRow_currentUser
    ...ActivityListItem_currentUser
  }
  fragment RecruitListItem_activity on Activity {
    id
    ...ActivityTableRow_activity
    ...ActivityListItem_activity
  }
`

interface RecruitListItemProps {
  isLoading?: boolean
  activity?: RecruitListItem_ActivityFragment
  currentUser?: RecruitListItem_CurrentUserFragment | null
  isRecommend?: boolean
  onClick?: () => void
}

const RecruitListItemDesktop: FC<RecruitListItemProps> = (props) => {
  const { isLoading, activity, currentUser, isRecommend, onClick } = props

  return (
    <ActivityTableRow
      className="activity-table-row"
      currentUser={currentUser}
      activity={activity}
      isLoading={isLoading}
      isRecommend={isRecommend}
      onClick={onClick}
    />
  )
}

export default RecruitListItemDesktop
